import { SelectionModel } from '@angular/cdk/collections';
import { DatePipe } from '@angular/common';
import { Component, Inject, OnInit, Optional } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef, MatDialogConfig } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { AccionesDialog, TiposMonedas, TiposMovimiento } from '@models/base/identificadores.model';
import { BonificacionDto } from '@models/bonificaciones/bonificacionDto.model';
import { MovimientoDetailDto } from '@models/movimiento/movimientoDetailDto.model';
import { MovimientoDto } from '@models/movimiento/movimientoDto.model';
import { TipoMovimientoDto } from '@models/tipos-movimiento/tipoMovimientoDto.model';
import { isFalsy } from 'utility-types';
import { DialogEditarMovimientosComponent } from '../dialog-editar-movimientos/dialog-editar-movimientos.component';
import { DialogNuevoMovimientoBonificacionComponent } from './dialog-nuevo-movimiento-bonificacion/dialog-nuevo-movimiento-bonificacion.component';
import { element } from 'protractor';
import { CreateMovimientoRequest } from '@models/movimiento/createMovimientoRequest.mode';
import { MovimientosService } from '@services/movimientos/movimientos.service';
import { SnackBarService } from '@services/snackBar/snack-bar-service.service';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-dialog-editar-bonificaciones',
  templateUrl: './dialog-editar-bonificaciones.component.html',
  styleUrls: ['./dialog-editar-bonificaciones.component.css'],
  providers: [
    [DatePipe],
  ],
})
export class DialogEditarBonificacionesComponent implements OnInit {

  //#region Variables

  numSelected: number = 0;
  displayedColumns: string[] = ['select', 'tipoBonificacion', 'detalle', 'importe', 'accion'];
  dataSource = new MatTableDataSource<MovimientoDetailDto>();
  selection = new SelectionModel<MovimientoDetailDto>(true, []);
  movimientosBonificaciones: MovimientoDetailDto[] = []

  /**
   * Saldo del pago del inquilino sin imputar, SIN contar bonificaciones: las que
   * se tildan acá se suman abajo, para ver en vivo cuánto poder de pago agregan.
   */
  saldoDisponible: number = 0

  //#endregion
  constructor(
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    private dialog: MatDialog,
    public dialogRef: MatDialogRef<DialogEditarMovimientosComponent>,
    public datepipe: DatePipe,
    private movimientosService: MovimientosService,
    private snackBar: SnackBarService,
    private spinner: NgxSpinnerService,
  ) { }


  ngOnInit(): void {
    this.movimientosBonificaciones = this.data.movimientosBonificaciones
    this.movimientosBonificaciones.forEach(element => {
      if (element.seleccionPago == true)
        this.selection.select(element)
    });
    this.dataSource.data = this.movimientosBonificaciones
    this.saldoDisponible = (this.data as any)?.saldoDisponible ?? 0
  }

  /** Total de las bonificaciones tildadas */
  getTotalBonificaciones(): number {
    const total = this.selection.selected
      .reduce((suma, bonificacion: any) => suma + (bonificacion.importe || 0), 0)

    return Math.round(total * 100) / 100
  }

  /**
   * Saldo resultante. A diferencia de las otras pantallas, acá tildar SUMA:
   * una bonificación no consume el pago, le agrega poder de pago.
   */
  getSaldoRestante(): number {
    return Math.round((this.saldoDisponible + this.getTotalBonificaciones()) * 100) / 100
  }

  onSubmit() {
    this.movimientosBonificaciones.forEach(element => {
      element.seleccionPago = false
    })
    let movimientosBonificaciones = this.selection.selected
    movimientosBonificaciones.forEach(element => {
      this.movimientosBonificaciones.forEach(element2 => {
        if (element.id == element2.id) {
          element2.bonificacion = element.bonificacion
          element2.descripcion = isFalsy(element.descripcion) ? "" : element.descripcion
          //Se agrega esto para evitar bonificaciones duplicadas
          element2.id = isFalsy(element.id) ? 0 : element.id
          element2.seleccionPago = true
          element2.periodoMes = new Date().getMonth() + 1
          element2.periodoAnio = new Date().getFullYear()
          element2.periodo = 0
          element2.importe = element.importe
          element2.tipoMovimiento = { id: TiposMovimiento.Bonificaciones, descripcion: "Bonificación", resta: true, editable: false, esAnulable: true,tieneComision:false }
          element2.seleccionPago = true
          let fechaEmision = isFalsy(this.datepipe.transform(new Date, 'yyyy-MM-dd')) ? "" : this.datepipe.transform(new Date, 'yyyy-MM-dd')
          element2.fechaEmision = isFalsy(fechaEmision) ? "" : fechaEmision;
          let fechaPago = this.datepipe.transform(new Date, 'yyyy-MM-dd') ? "" : this.datepipe.transform(new Date, 'yyyy-MM-dd')
          element2.fechaPago = isFalsy(fechaPago) ? "" : fechaPago;
        }
      })
    });

    this.dialogRef.close({ data: this.movimientosBonificaciones, event: AccionesDialog.Aceptar });
  }

  onCancel() {
    this.dialogRef.close({ data: this.movimientosBonificaciones, event: AccionesDialog.Cancelar });
  }

  openDialogNuevoBonificacion() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.width = "30%"
    dialogConfig.autoFocus = false;
    dialogConfig.data = {
      event: AccionesDialog.Agregar,
      importe: 0,
      bonificaciones: new BonificacionDto,
      contrato: this.data.contrato
    }

    let dialogRef = this.dialog.open(DialogNuevoMovimientoBonificacionComponent,
      dialogConfig);

    dialogRef.afterClosed().subscribe(result => {
      if (result && result.event == AccionesDialog.Agregar) {
        let importe = result.data.importe as number
        let fechaEmision = isFalsy(this.datepipe.transform(new Date, 'yyyy-MM-dd')) ? "" : this.datepipe.transform(new Date, 'yyyy-MM-dd')
        let fechaPago = isFalsy(this.datepipe.transform(new Date, 'yyyy-MM-dd')) ? "" : this.datepipe.transform(new Date, 'yyyy-MM-dd')

        let createMovimientoRequest: CreateMovimientoRequest = new CreateMovimientoRequest
        createMovimientoRequest.descripcion = result.data.descripcion
        createMovimientoRequest.idTipoMovimiento = TiposMovimiento.Bonificaciones
        createMovimientoRequest.idBonificacion = result.data.bonificacion.id
        createMovimientoRequest.importe = importe
        createMovimientoRequest.periodo = 0
        createMovimientoRequest.fechaPago = isFalsy(fechaPago) ? "" : fechaPago;
        createMovimientoRequest.fechaEmision = isFalsy(fechaEmision) ? "" : fechaEmision;
        createMovimientoRequest.idMovimientoRef = null
        createMovimientoRequest.idPeriodoContrato = null
        createMovimientoRequest.idTipoMoneda = TiposMonedas.Pesos
        createMovimientoRequest.periodoMes = new Date().getMonth() + 1
        createMovimientoRequest.periodoAnio = new Date().getFullYear()
        createMovimientoRequest.idContrato = this.data.contrato.id
        createMovimientoRequest.idInquilino = this.data.contrato.inquilino.id

        this.createMovimiento(createMovimientoRequest)
      }

    });
  }


  createMovimiento(createMovimientoRequest: CreateMovimientoRequest) {
    this.spinner.show("spMovimiento")
    this.movimientosService.createMovimientosConBonificacion(createMovimientoRequest, true)
      .subscribe(
        data => {
          this.spinner.hide("spMovimiento")
          this.snackBar.showSuccess("Movimiento creado correctamente.", "Exito")
          data.forEach(movimiento => {
            this.agregarBonificacionAMovimiento(movimiento);
          });
        },
        error => {
          this.spinner.hide("spMovimiento")
          this.snackBar.showError(error, "Error");
        })
  }

  eliminarBonifiacion(element: any) {
    this.spinner.show("spMovimiento")
    // Se usa el borrado en cascada: la bonificación genera movimientos
    // encadenados (deuda al propietario, egreso de caja) y el delete común
    // falla por referencias.
    this.movimientosService.deleteConVinculados(element.id)
      .subscribe(
        data => {
          this.spinner.hide("spMovimiento")
          this.dataSource.data = this.dataSource.data.filter((value, key: any) => {
            return value != element
          });
          this.movimientosBonificaciones.forEach((movimiento, index) => {
            if (movimiento == element)
              this.movimientosBonificaciones.splice(index, 1);
          });
          this.data = this.dataSource.data.length >= 1 ? true : false

          this.snackBar.showSuccess("Movimiento eliminado correctamente.", "Exito")
        },
        error => {
          this.spinner.hide("spMovimiento")
          this.snackBar.showError(error, "Error");
        })
  }


  agregarBonificacionAMovimiento(movimientoDetailDto: MovimientoDetailDto) {
    this.movimientosBonificaciones.push(movimientoDetailDto)
    this.selection.select(movimientoDetailDto)
    this.movimientosBonificaciones.forEach(element => {
      if (element.seleccionPago == true)
        this.selection.select(element)
    });
    this.dataSource.data = this.movimientosBonificaciones
  }


  isAllSelected() {
    this.numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    return this.numSelected === numRows;
  }


  masterToggle() {
    if (this.isAllSelected()) {
      this.selection.clear();
      return;
    }
    this.selection.select(...this.dataSource.data);
  }

  checkboxLabel(row?: MovimientoDetailDto): string {
    if (!row) {
      return `${this.isAllSelected() ? 'deselect' : 'select'} all`;
    }
    return `${this.selection.isSelected(row) ? 'deselect' : 'select'} row ${row.id}`;
  }
}


